export default __webpack_public_path__ + "static/media/ufo.b20e3c98.png";